<template>
    <el-dialog
        title="试题组卷"
        :visible.sync="visible"
        width="11rem"
        class="step-audit-dialog"
        key="exam3Dialog"
        :before-close="handleDialogClose">
        <div class="step-exam-item-btn">
            <el-button size="mini" @click="addSubjectItem">新增试题</el-button>
            <el-button size="mini" @click="chooseSubjectItems">试题组卷</el-button>
        </div>
        <div class="step-exam-group">
            <score-table :questionItems="questionData"></score-table>
            <div class="section-questionData">
                <div class="items" v-for="(items, index) in questionData" :key="index">
                <div class="header">
                    <div class="name">
                    {{ index + 1 }}.
                    <el-tag size="small" type="success">{{ typeObj[items.type] }}</el-tag>
                    <el-tag size="small" type="info" v-if="items.isRequired >= 0">{{ items.isRequired ? '必答' : '选答' }}</el-tag>
                    <span>{{ items.title }}</span>
                    </div>
                    <div class="btn">
                    <el-tag type="success" style="margin-right: 20px;">题目分数: {{ items.score }}</el-tag>
                    <el-button type="text" @click="handleSwapArr(index, 'up')">上移</el-button>
                    <el-button type="text" @click="handleSwapArr(index, 'bottom')">下移</el-button>
                    <el-button type="text" @click="questionData.splice(index, 1)">删除</el-button>
                    </div>
                </div>
                <div class="options" v-if="items.type != 2">
                    <div class="options--items" v-for="(item, childIndex) in items.subjectItemResults" :key="childIndex">
                    {{ String.fromCharCode(childIndex + 65) }}. {{ item.content }}
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button type="primary" size="mini" @click="handleDialogClose">取消</el-button>
            <el-button type="primary" size="mini" @click="handleDialogConfirm">确认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import scoreTable from './scoreTable'

export default {
    name: 'paperDialog',
    props: ['visible', 'questionData'],
    components: { scoreTable },
    data() {
        return {
            typeObj: { 0: '单选',1: '多选',2: '问答',3: '填空',4: '评分',5: '判断' },
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit('closeDialog')
        },
        handleDialogConfirm() {
            if (this.questionData.length === 0) {
                this.$message({ type: 'warning', message: '请关联卷宗' })
                return
            }
            this.$emit('confirmDialog', this.questionData)
        },
        addSubjectItem() {
            this.$emit('addSubjectItem')
        },
        chooseSubjectItems() {
            this.$emit('chooseSubjectItems')
        },
        handleSwapArr(index, type) {
            if (type === 'up') {
                if (!index) return
                // 在上一项插入该项
                this.questionData.splice(index - 1, 0, (this.questionData[index]))
                // 删除后一项
                this.questionData.splice(index + 1, 1)
            } else {
                if (index === (this.questionData.length - 1)) return
                // 在下一项插入该项
                this.questionData.splice(index + 2, 0, (this.questionData[index]))
                // 删除前一项
                this.questionData.splice(index, 1)
            }
        },
    }
}
</script>